import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatchTokenComponent } from '../catch-token/catch-token.component';
import routerConfig from '../configs/router.config';
import { WhiteLabelGuard } from '../guards/whitelabel.guard.service';
import { AccountConfirmComponent } from './account-confirm/account-confirm.component';
import { RegisterComponent } from './register/register.component';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./container/container.component').then((x) => x.ContainerComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        title: 'auth.login.title',
        loadComponent: () => import('./login/login.component').then((x) => x.LoginComponent),
      },
      {
        path: 'forgot',
        title: 'auth.forgot_password.title',
        loadComponent: () => import('./forgot-password/forgot-password.component').then((x) => x.ForgotPasswordComponent),
      },
      {
        path: 'set-password',
        title: 'auth.set_password.title',
        loadComponent: () => import('./set-password/set-password.component').then((x) => x.SetPasswordComponent),
      },
      {
        path: 'verify/:token',
        title: 'auth.account_confirm.title',
        component: AccountConfirmComponent,
      },
      {
        path: 'token/:token',
        component: CatchTokenComponent,
      },
      {
        path: 'verify-email',
        loadComponent: () => import('./verify-email/verify-email.component'),
      },
    ],
  },
  {
    path: 'register',
    title: 'auth.register.register_link_txt',
    canActivate: [WhiteLabelGuard],
    data: routerConfig.authRegister,
    component: RegisterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
